module.exports = __webpack_public_path__ + "814fdc51e9461a52e44292d6520d74c7.svg";